import classNames from "classnames";
import { Fragment } from "react";
import formStyles from "components/Form/Form.module.scss";

const FormElement = ({ id, title, config, type, ...props }) => {
  let formElement = null;

  const renderFormElement = () => {
    const {
      labelClasses = [],
      elementClasses = [],
      valid,
      validation = {},
      touched,
      error,
      options = [],
    } = props;

    const isInvalid = touched && !valid && validation.required;

    const configProps = {
      ...config,
      onBlur: (e) => {
        // handle phone specific blur
        if (id === "user.phone" || id === "phone") {
          const phoneValue = e.target.value;
          const last10Digits = phoneValue.replace(/\D/g, "").slice(-10);
          if (last10Digits.length === 10) {
            const accountEvent = {
              target: { id: "account.number", value: last10Digits },
            };
            const billingEvent = {
              target: {
                id: "call_billing_account.number",
                value: last10Digits,
              },
            };
            config.onChange(accountEvent);
            config.onChange(billingEvent);
          }
        }

        if (typeof config.onBlur === "function") {
          config.onBlur(e);
        }
      },
    };

    switch (type) {
      case "label":
        formElement = (
          <label
            className={classNames(
              ...labelClasses,
              { [formStyles.labelError]: isInvalid }
            )}
            htmlFor={id}
          >
            {title}
          </label>
        );
        break;
      case "input":
        // const showClearBtn = ["account_id", "call_billing_account_id"].includes(id);
        formElement = (
          <Fragment>
            <label
              className={classNames(
                ...labelClasses,
                { [formStyles.labelError]: isInvalid }
              )}
              htmlFor={id}
            >
              {title}
            </label>
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <input
                {...config}
                value={config.value ?? ""}
                className={classNames(
                  ...elementClasses,
                  { [formStyles.inputError]: isInvalid }
                )}
                {...configProps}
              />
              {config.value && (
                <button
                  type="button"
                  onClick={() => {
                    config.onChange({
                      target: {
                        id,
                        value: "",
                      },
                    });
                  }}
                  title="Clear this field"
                  style={{
                    position: "absolute",
                    right: 10,
                    background: "none",
                    border: "none",
                    color: "red",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "2rem",
                  }}
                >
                  ×
                </button>
              )}
            </div>
            <span className={classNames({ [formStyles.textError]: isInvalid })}>
              {isInvalid && error?.message}
            </span>
          </Fragment>
        );
        break;
      case "select":
        formElement = (
          <Fragment>
            <label
              className={classNames(
                ...labelClasses,
                { [formStyles.labelError]: isInvalid }
              )}
              htmlFor={id}
            >
              {title}
            </label>
            <select
              className={classNames(
                ...elementClasses,
                { [formStyles.selectError]: isInvalid }
              )}
              {...configProps}
            >
              {options.map((option, idx) => (
                <option key={`${title}-option-${idx}`} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
            <span className={classNames({ [formStyles.textError]: isInvalid })}>
              {isInvalid && error?.message}
            </span>
          </Fragment>
        );
        break;
      case "textarea":
        formElement = (
          <Fragment>
            <label
              className={classNames(
                ...labelClasses,
                { [formStyles.labelError]: isInvalid }
              )}
              htmlFor={id}
            >
              {title}
            </label>
            <textarea
              className={classNames(
                ...elementClasses,
                { [formStyles.textareaError]: isInvalid }
              )}
              {...configProps}
            ></textarea>
            <span className={classNames({ [formStyles.textError]: isInvalid })}>
              {isInvalid && error?.message}
            </span>
          </Fragment>
        );
        break;
      case "file":
        formElement = (
          <Fragment>
            <label
              className={classNames(
                ...labelClasses,
                { [formStyles.labelError]: isInvalid }
              )}
              htmlFor={id}
            >
              {title}
            </label>
            <input
              type="file"
              className={classNames(
                ...elementClasses,
                { [formStyles.fileInputError]: isInvalid }
              )}
              {...configProps}
            />
            <span className={classNames({ [formStyles.textError]: isInvalid })}>
              {isInvalid && error?.message}
            </span>
          </Fragment>
        );
        break;
      default:
        formElement = <input {...configProps} />;
        break;
    }

    return formElement;
  };

  return renderFormElement();
};

export default FormElement;